import React from "react";
import "./postType.css";
import onClickOutside from "react-onclickoutside";
import {Link} from "react-router-dom"

function PostTypes({isPostSelect,close}) {
    PostTypes.handleClickOutside = () => close();
    return (
        <React.Fragment>
            <div className={`postType__container ${isPostSelect ? 'hidden' : ''}`}>
                <div className="postTypes__wrapper py-4 px-3 rounded-xl bg-white border shadow-sm">
                    <ul className="m-0">
                        <li className=" py-1 rounded-lg pl-2">
                            <Link to="/createblogs" className="text-black no-underline block">Blogs</Link>
                        </li>
                        <li className=" py-1 rounded-lg pl-2">
                            <Link to="/createquestions" className="text-black no-underline block">Questions</Link>
                        </li>
                        {/* <li className=" py-1 rounded-lg pl-2">
                            <Link to="/createpolls" className="text-black no-underline block">Polls</Link>
                        </li> */}
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => PostTypes.handleClickOutside
  };

export default onClickOutside(PostTypes, clickOutsideConfig);
